import { type MenuLink } from "core-fe-lib/components-shadcn/types/menu-link";

export function getOutboxLinks(t: any, icon: string = "outbox"): MenuLink[] {
  return [
    {
      title: t("layout.navigation.outbox.title"),
      caption: t("layout.navigation.outbox.caption"),
      icon,
      items: [
        {
          title: t("layout.navigation.outbox.messages.title"),
          caption: t("layout.navigation.outbox.messages.caption"),
          icon: "list",
          link: "/outbox",
        },
      ],
    },
  ];
}
